<template>
	<b-button
		:class="classes"
		v-bind="$attrs"
		@click="handleDelete">
		<slot />
	</b-button>
</template>
<script>

export default {
	props: {
		model: {
			type: String,
			default: null
		},
		modelId: {
			type: Number,
			default: null
		},
		classes: {
			type: String,
			default: ''
		},
		prefix: {
			type: String,
			default: 'admin.'
		},
		only: {
			type: Array,
			default: () => []
		},
		trash: {
			type: Boolean,
			default: () => false
		},
		purge: {
			type: Boolean,
			default: () => false
		}
	},
	computed: {
		okTitle () {
			return this.trash ? 'Trash' : 'Delete Forever'
		},
		message () {
			return this.trash
				? 'Are you sure you want to trash this record? You can restore it later.'
				: 'Are you sure you want to delete this record and any related data? This cannot be undone.'
		},
		targetRoute () {
			return this.purge
				? this.route(this.prefix + this.model + '.purge', this.modelId)
				: this.route(this.prefix + this.model + '.destroy', this.modelId)
		}
	},
	methods: {
		handleDelete () {
			this.$emit('deleting')
			const route = this.targetRoute
			const msg = this.message

			this.$bvModal.msgBoxConfirm(msg, {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				bodyBgVariant: 'dark',
				headerBgVariant: 'dark',
				footerBgVariant: 'dark',
				okVariant: 'danger',
				okTitle: this.okTitle,
				cancelTitle: 'Cancel',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (!value) {
					return
				}

				this.$inertia.delete(route, {
					only: [...this.only, ...['flash']],
					preserveScroll: true,
					onError: (errors) => {
						this.$emit('error', errors)
					},
					onSuccess: () => {
						// WARNING: If the delete action also removes this component, this emit event will never fire
						this.$emit('deleted')
					}
				})
			})
		}
	}
}
</script>
